export function getRefineGoldPrice(level = 0) {
  return (level + 1) * 500000
}
export function getRefineStonePrice(level = 0) {
  if (level < 5) {
    return 10 * (level + 1)
  } else if (level < 10) {
    return 100 + (level - 5) * 10
  } else if (level < 15) {
    return 200 + (level - 10) * 50
  }
  return 0
}

export function getEngravePrice(count = 0, level = 5) {
  let value = 0
  if (count > 10) return (value = 50000000)
  value = count * 5000000
  return value * (level / 5)
}

export function getDisassembleResStone(level: number) {
  let res = 0
  for (let i = level; i > 0; i--) {
    res += getRefineStonePrice(i - 1)
  }
  return res
}

export function getReforgePrice(level: number) {
  return level * 1000
}
